export default __webpack_public_path__ + "5b4d4a7f81de0d33c6b970adeb7ae535.png";